




































import {Vue, Component} from "vue-property-decorator";
import {user} from "@/store/types";
import {MutationList as userMutations} from "@/store/modules/user/mutation-list";
import axios from 'axios';
import {MutationList as modalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class FamilyMemberList extends Vue {
    private userNamespace = 'user/';
    private modalNamespace = 'modal/';
    private user: user = {
        name: '',
        surname: '',
        address: '',
        appointments: []
    };

    // async save user

    async saveNewUser() {
        this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'Saving data');
        await axios.post('http://someurl.com', this.user)
            .then(() => {
                this.$store.commit(`${this.userNamespace}${userMutations.SAVE_NEW_RELATIVE}`, this.user);
                this.clearUserFormData();
                this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
                this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_SMALL_MODAL}`, {message: 'data saved', title: 'Success!!'});
                this.back();
            })
            .catch(e => {
                this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                    header: 'an error happened while saving member',
                    message: e
                });
            });

    }

    // clear user information
    clearUserFormData() {
        this.user = {
            name: '',
            surname: '',
            address: '',
            appointments: []
        }
    }

    // function that returns back to family list
    back(){
        this.$router.replace('/family');
    }
}
